import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Subject } from "rxjs";
import { Route, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';

@Injectable({
  providedIn: 'root'
})
export class PlayerServicesService {

  url: any = environment.API_URL;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private route: Router,

  ) { }

  getEventByDate(data: any) {
    return this.http.post(this.url + 'player/getEventsBySelectedDate', data);
  }

  getUpcomingOrders(data: any) {
    return this.http.post(this.url + `player/getUpcomingOrders`, data);
  }

  getPlayerCanceledOrders() {
    return this.http.get(this.url + 'player/getCancelledOrders');
  }

  getRestaurant(res_body: any) {
    return this.http.post(this.url + 'player/getRestaurants', res_body);
  }

  getRestaurantProductsPlayers(res_body: any) {
    return this.http.post(this.url + 'player/getRestaurantProducts', res_body);
  }


  getPlayerCart() {
    return this.http.get(this.url + 'player/getCart');
  }

  getPlayerNotification() {
    return this.http.get(this.url + 'player/getNotifications');
  }

  playerAddOrder(data:any){
    return this.http.post(this.url + 'player/addOrder', data);
  }

  playerUpcoingOrders(){
    return this.http.get(this.url + 'player/getUpcomingOrders');
  }

  playerUpcoingOrderscurrentDate(currentDate:any){
    return this.http.get(this.url + 'player/getUpcomingOrders?currentDate='+currentDate);
  }

  playerPastOrders(data:any){
    return this.http.post(this.url + 'player/getPastOrders',data);
  }

  coachPastOrders(data:any){
    return this.http.post(this.url + 'club/getPastOrders',data);
  }

  playerUpcoingOrdersByDate(data:any){
    return this.http.post(this.url + 'player/getDateWiseUpcomingOrders',data);
  }

  // playerUpcoingOrdersByDate(data:any){
  //   return this.http.get(this.url + 'player/getUpcomingOrders',data);
  // }

  

  
  playergetOrdersById(id:any){
    return this.http.get(this.url + 'player/getOrder/'+id);
  }

  playerDelveredOrders(){
    return this.http.get(this.url + 'player/getDeliveredOrders');
  }

  getFavouriteOrdersPlayer(){
    return this.http.get(this.url + 'player/favouriteorders');
  }

  removeFavouriteOrder(data:any){
    return this.http.post(this.url + 'player/remove/fav/order',data);
  }

  playerPayNow(data){
    return this.http.post(this.url + 'player/pay/paymentNow',data)
  }

  addFavouriteOrder(data:any){
    return this.http.post(this.url + 'player/fav/order',data);
  }


  playerCancelOrder(id:any){
    return this.http.put(this.url + 'player/cancel/order/'+id,{});
  }

  paymentRequest(data:any){
    return this.http.post(this.url + 'club/pay/paymentrequests',data);
  }

  joinTeam(data:any){
    return this.http.post(this.url + 'team/add/team',data);
  }

  saveNotes(data: any){
    return this.http.put(this.url + 'player/updateCartNotes', data);
  }
}